exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chartContainer[data-v-4dd4b244] {\n  position: relative;\n  height: 40vh;\n  min-height: 300px;\n}\n#usageChart[data-v-4dd4b244] {\n  width: 100%;\n}\n", ""]);

// exports
